/**
 * Saisie d'une liste de destinataires (adresses e-mail, conversations Telegram)
 * dans un champ texte libre.
 *
 * Le champ garde le texte BRUT de l'opérateur et n'en dérive la liste qu'à la
 * lecture. L'ancienne saisie réécrivait le champ depuis la liste à chaque
 * frappe : le retour à la ligne (ou la virgule) tapé après une adresse
 * produisait une entrée vide, aussitôt filtrée, et disparaissait — impossible
 * de taper une deuxième adresse, seul le collage fonctionnait.
 */

/** Séparateurs acceptés : retour à la ligne, virgule, point-virgule, espace. */
const SEPARATORS = /[\n,;\s]+/

export function parseRecipientList(raw: string): string[] {
  const seen = new Set<string>()
  const result: string[] = []
  for (const entry of raw.split(SEPARATORS)) {
    const value = entry.trim()
    if (value === '' || seen.has(value.toLowerCase())) continue
    seen.add(value.toLowerCase())
    result.push(value)
  }
  return result
}

/** Même règle que le serveur (`z.string().email()`), en plus tolérant sur le domaine. */
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

/** Identifiant Telegram : entier signé (groupes en -100…) ou @canal public. */
const CHAT_ID_PATTERN = /^(-?\d+|@[A-Za-z0-9_]{4,})$/

export type RecipientKind = 'email' | 'telegram'

export function invalidRecipients(entries: readonly string[], kind: RecipientKind): string[] {
  const pattern = kind === 'email' ? EMAIL_PATTERN : CHAT_ID_PATTERN
  return entries.filter(entry => !pattern.test(entry))
}

/** Le texte brut décrit-il encore la liste enregistrée ? Sinon, il faut le resynchroniser. */
export function draftMatches(raw: string, entries: readonly string[]): boolean {
  const parsed = parseRecipientList(raw)
  return parsed.length === entries.length && parsed.every((entry, index) => entry === entries[index])
}
